import { useMutation, useQuery,useLazyQuery } from "@apollo/client";
import { Grid } from "@material-ui/core";
import Box from '@mui/material/Box';
import { useHistory, useParams } from "react-router-dom";
import { useState, useEffect, useContext, useCallback } from "react";
import styles from "../../src/components/Payroll/PayrollStyles.module.css"
import { 
        GET_EVENTUALCOLLABORATORTIMBRADO,        
        GET_EVENTUALPAYROLL,        
        GET_ALL_COMPANY,
        UPDATE_EVENTUALPAYROLL_STATE,        
      } from "../Querys/querys";
import { PAYROLL_EVENTUAL_STAMP,
        GET_STATUS_PAYROLL_STAMP_EVENTUAL 
        } from "../Querys/stampPayroll/querys";            
import CustomTabs from '../components/Collaborators/Tab/CustomTabs';
import CustomTab from '../components/Collaborators/Tab/CustomTabMain';
import {formatter} from "../helpers/formatoMoneda"
import descargaXml from "../assets/svg/icono_descarga_xml.svg";
import CheckPermission from "../helpers/Administradores/Permissions";
import { server } from "../global/server";
import prefactura from "../assets/svg/icono_prefactura.svg";
import iconoPDF from "../assets/svg/icono_descargar_pdf.svg";
import PayrollProcessContext,{ Types }  from "../context/PayrollProcess/PayrollProcessContext";
import { openFinish } from "../context/PayrollProcess/Actions";
import ShowTerminar from "../components/Payroll/Modals/ShowTerminar/ShowTerminar"
import { AttentionAlert2 } from "../alerts/attentionAlert2";
import LockedSystem from "../alerts/LockedSystem";
import moment from "moment";
import {DataCancelTimbre} from "../components/Payroll/Modals/CancelTimbre/DataCancelTimbre"
import { AdminContext } from "../context/AdminContext/AdminContext";
import { LoadingAlert } from "../alerts/loadingAlerts";
import { WarningAlertTimbre } from "../alerts/WarningAlertTimbre";
import { ErrorAlert } from "../alerts/errorAlert";
import { SuccessfulAlert } from "../alerts/successAlerts";
import iconoPDFAnterior from "../assets/svg/Alert_Icon.svg";
import { 
         FormControlLabel, 
         Checkbox } from "@mui/material";
import axios from "axios";
interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

const EventualPayrollTimbrar = (props: TabPanelProps) => {
  const {state,dispatch} = useContext(PayrollProcessContext)
  const { id, tab } = useParams<any>();
  const [filtrado, setFiltrado] =  useState<any[]>([])
  const [isCheck, setIsCheck] =  useState<any[]>([])
  const [timbrar, setTimbrar] =  useState(true)
  const [activeReStamp, setActiveReStamp] = useState(false);  
  const history = useHistory();  
  const [payrollCancel, setPayrollCancel] =  useState<any[]>([])
  const {adminState} = useContext(AdminContext)
  const {loading, data:payrollDataDispersar} = useQuery(GET_EVENTUALPAYROLL, {
    variables: { getEventualPayrollId: id },
  });

  const [getPayrollDataDispersar, setGetPayrollDataDispersar] = useState<any>(payrollDataDispersar)

  const [year , setYear] = useState<any>()
  
  useEffect(() => {
    if(payrollDataDispersar){
      setYear(moment(payrollDataDispersar?.init_date).format("YYYY"))
      setGetPayrollDataDispersar(payrollDataDispersar?.GET_EVENTUALPAYROLL)
    }
  } ,[payrollDataDispersar])

  const { data: resultPayrollTimbrado, refetch: refetchPayrollEventualTimbrado } = useQuery(GET_EVENTUALCOLLABORATORTIMBRADO, {
    variables: { getSettlementPayrollcollaboratorTimbradoId: id },
  });
  
  const allPayrollTimbrado = resultPayrollTimbrado?.GET_EVENTUALCOLLABORATORTIMBRADO;

  const handleChange = () =>{
  }
  const [getCollaboratorStatusEventual] = useLazyQuery(GET_STATUS_PAYROLL_STAMP_EVENTUAL);
  /*--------------------------sistemaActivo--------------------*/
  const { data: resultCompany, startPolling, stopPolling } = useQuery(GET_ALL_COMPANY);
  const myCompany = resultCompany?.GET_ALL_COMPANY;
  const [sistemaActivo, setSistemaActivo] = useState<any>(true);
 
  useEffect(()=>{
    startPolling(1000);
    return () =>{
      stopPolling()
    }
  },[startPolling,stopPolling])

  useEffect(() => {
    if(myCompany){
      setSistemaActivo(myCompany[0]?.SistemaActivo)
    }
  }, [myCompany]);
  /*--------------------------sistemaActivo--------------------*/

  const obtenerDatos = useCallback(async () => {
    await setFiltrado(allPayrollTimbrado?.filter((item:any) => item.dispersionStatus === "LIQUIDADO"))
    setPayrollCancel(
      allPayrollTimbrado?.filter((item:any) => item.AcuseCancelacion || (item.PDF_back && item.PDF_back !== ""))
    )
  }, [allPayrollTimbrado]);

  useEffect(() => {
    obtenerDatos();
  }, [allPayrollTimbrado, obtenerDatos]);

  const datosFiltrados = (e:any) =>{
    if(e !== '') {
      let expresion = new RegExp(`${e}.*`, "i")
      const nuevoFiltrado = filtrado.filter((lis:any) => expresion.test(lis.colaborator))
      setFiltrado(nuevoFiltrado)
    }else{
      setFiltrado(
        allPayrollTimbrado?.filter((item:any) => item.dispersionStatus === "LIQUIDADO")
      )
    }
  }

  const updateState = (idPayroll:any) =>{
    const payronTimbrados = filtrado?.filter((item:any) => item.UUID !== null)
    const payronNoTimbrados = filtrado?.filter((item:any) => item.UUID === null)

    if(payronNoTimbrados?.length === 0){
      openFinish({idPayroll}, dispatch)
    }
    else{     
      AttentionAlert2({
                        text:"Se timbraron "+ payronTimbrados?.length + " nominas, faltan "+ payronNoTimbrados?.length + " nominas por timbrar"
                      });
    }
  }

  const [payrollEventualStamp] = useMutation(PAYROLL_EVENTUAL_STAMP);  

  const handleSelectAll = (e:any) =>{
    if(!e.target.checked){
      setIsCheck([])
    }
    if(activeReStamp){
      let filtradoSeleccionado = (allPayrollTimbrado.filter((lis:any)=>{
      return e.target.checked && !isCheck.includes(lis.id) }).map((lis:any) =>(lis.id)))
      setIsCheck(filtradoSeleccionado)
    }else{
    let filtradoSeleccionado = (allPayrollTimbrado.filter((lis:any)=>{
      return e.target.checked && !isCheck.includes(lis.id) 
                              && ((!lis.UUID || lis.UUID === "") 
                              || ((lis.AcuseCancelacion && lis.AcuseCancelacion !== "") && (lis.UUID && lis.UUID !== "") )
                              || ((!lis.AcuseCancelacion || lis.AcuseCancelacion === "") 
                              && (!lis.UUID || lis.UUID === "") 
                              && (lis.PDF_back && lis.PDF_back !== "")))
    }).map((lis:any) =>(lis.id)))
    setIsCheck(filtradoSeleccionado)
   }
  }

  const handleClick =  (e:any) => {
    const {id, checked} = e.target  
    setIsCheck([...isCheck, id])
    if(!checked){
      setIsCheck(isCheck.filter((lis:any) => lis !== id))
    }

  }

  const handleCollaboratorUpdates = (data:any) => {
    let text = "";
    let textTimbre = "";
    console.log(data)
    const filteredData = data.filter((item: { MensajeIncidencia: string; UUID: string; }) => item.MensajeIncidencia !== "" && item.UUID === "");
    if(filteredData.length > 0 ){
      for (const responseSEllO of filteredData) {
        const { MensajeIncidencia, Colaborador, CodigoError } = responseSEllO;
        const mensaje =MensajeIncidencia === ""
          ? "No se recibió respuesta del servicio, no se ha timbrado el documento, favor de volverlo a intentar."
          : MensajeIncidencia;  
        text += `<b>Problema Colaborador:</b><br><b>${Colaborador}:</b> ${CodigoError} ${mensaje}<br>`;
      }
      if (text !== "" || textTimbre !== "") {
        WarningAlertTimbre({ text: textTimbre + text });
      }
     }else{
      SuccessfulAlert({text:'El proceso de timbrado se completó exitosamente'})
     }
  };

  const timbrarNomina = async () =>{
    const collaboratorSize=  isCheck.length 
    const timeInterval= collaboratorSize > 50 ? 10000 : 1000;
    if (collaboratorSize > 0) {
      setTimbrar(false);
      LoadingAlert({ title: "Cargando..." });
      try {
        const payEvenStampRes = await payrollEventualStamp({
          variables: {
            idPayrollEventual: id,
            stampAgain: false,
            idCols: isCheck,
            userAdd: adminState?.Usuario
          },
        }); 
         const responseToken = payEvenStampRes.data.PAYROLL_EVENTUAL_STAMP.token;                               
         const interval = setInterval(async () => {
          const { data } = await getCollaboratorStatusEventual({
              variables: {              
                idPayrollEventual: id,
                idTracking: responseToken                    
              }
            });          
         if (data.GET_STATUS_PAYROLL_STAMP_EVENTUAL[0].status === 'finalized') {
              refetchPayrollEventualTimbrado()    
              setTimbrar(true) 
              setIsCheck([])
              handleCollaboratorUpdates(data.GET_STATUS_PAYROLL_STAMP_EVENTUAL[0].collaboratorsEventualResponse );                    
              clearInterval(interval)
              return 
              }
              
            }, timeInterval);                   
          setTimeout(() => {
          }, 100); 

      } catch(error) {
        console.error("Error al timbrar nómina eventual:", error);
        setTimbrar(true);
        ErrorAlert({ text: `Hubo un error al procesar la nómina eventual. Por favor, intente nuevamente.` });
      }
    }
  }
  
 const openDataCancel = (_id: any, typeCancelTimbre: any,payroll_type:any) =>{
       dispatch({
         type: Types.SAVE_INFORMATION_PAYROLL,
         payload: {
                   typeCancelTimbre,
                   payroll_type}
       });
     history.push(`/PayrollCancelTimbrarEventual/${_id}/0/0`)
  }

  const handleChangeActiveReStamp = (event:any) => {
    setActiveReStamp(event.target.checked);
  }
  
  const [updatePayroll] = useMutation(UPDATE_EVENTUALPAYROLL_STATE);

  const updateStateNomine = (id: any) => {
    if(!payrollDataDispersar?.dateFinish ){
      updatePayroll({
        variables: {
          input: {
            id: id,
            statusProgress: "Terminar",
          },
        },
      });
    } 
  };

  const bottonfinish = () =>{
    const timbrados: any = filtrado?.filter((lis:any) => lis.UUID !== null && lis.UUID !== "")
    const terminados: any = filtrado?.filter((lis:any) => lis.status === "Terminado")
    return <>
      {
        terminados?.length === 0?
          (timbrados?.length > 0)?
            <button className={styles.pt_botonFinalizar}
            onClick={() =>
            {              
                updateState(id)
            }}
            >
              <div>
                Terminar
              </div>
              <div className={styles.pc_iconoDispersar}></div>
            </button>
          :
            <button className={styles.pt_botonFinalizar}
            style={{opacity:0.5}}
            >
              <div>
                Terminar
              </div>
              <div className={styles.pc_iconoDispersar}></div>
            </button>
        :
          <button className={styles.pt_botonFinalizar}
          onClick={() =>
          {
            updateStateNomine(id)
              history.push(`/PayrollEventualTerminar/${id}/${tab}`)
          }}
          >
            <div>
              Terminar
            </div>
            <div className={styles.pc_iconoDispersar}></div>
          </button>
      }
    </>
  }

  const timbrarNominaCancelada = async () =>{
    const collaboratorSize=  isCheck.length 
    const timeInterval= collaboratorSize > 50 ? 10000 : 1000;
    if (collaboratorSize > 0) {
      setTimbrar(false);
      LoadingAlert({ title: "Cargando..." });
      try {
        const payEvenStampRes = await payrollEventualStamp({
          variables: {
            idPayrollEventual: id,
            stampAgain: true,
            idCols: isCheck,
            userAdd: adminState?.Usuario
          },
        }); 
         const responseToken = payEvenStampRes.data.PAYROLL_EVENTUAL_STAMP.token;                               
         const interval = setInterval(async () => {
          const { data } = await getCollaboratorStatusEventual({
              variables: {              
                idPayrollEventual: id,
                idTracking: responseToken                    
              }
            });          
         if (data.GET_STATUS_PAYROLL_STAMP_EVENTUAL[0].status === 'finalized') {
              refetchPayrollEventualTimbrado()    
              setTimbrar(true) 
              setIsCheck([])
              handleCollaboratorUpdates(data.GET_STATUS_PAYROLL_STAMP_EVENTUAL[0].collaboratorsEventualResponse );                    
              clearInterval(interval)
              return 
              }
              
            }, timeInterval);                   
          setTimeout(() => {
          }, 100); 

      } catch(error) {
        console.error("Error al timbrar nómina eventual:", error);
        setTimbrar(true);
        ErrorAlert({ text: `Hubo un error al procesar la nómina eventual. Por favor, intente nuevamente.` });
      }
    }
  }

  const exportarPDF = async (id: any) => {    
    const PDF: any = await axios.get(`${server}/report/pdfPayRollEventual/${id}`)
    const link = document.createElement("a");
    link.href = PDF?.data?.urlPDF;
    link.setAttribute("download", "downloadtesting.PDF");
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

const isValidPayroll = (payroll: any): boolean => {
  const condition =
    (!payroll.UUID || payroll.UUID === "") ||
    ((payroll.AcuseCancelacion && payroll.AcuseCancelacion !== "") &&
      (payroll.UUID && payroll.UUID !== "")) ||
    ((!payroll.AcuseCancelacion || payroll.AcuseCancelacion === "") &&
      (!payroll.UUID || payroll.UUID === "") &&
      (payroll.PDF_back && payroll.PDF_back !== ""));
  if(activeReStamp){
    return false
  } else{
   return condition ? false : true;
  }
  };


  return (
    <>
      {!sistemaActivo ? (
        <LockedSystem/>
      ) : null}
      <Box mt={3} ml={5} className="Title">
        Nóminas
      </Box>
      <Box p={5} pb={3} pt={0}>
        <Grid
          container
          justify="flex-start"
        >
          <CustomTabs
            //Tiene que ser 3 para que se muestre la pestaña de Eventuales
            value={3}
            onChange={handleChange}
            aria-label="simple tabs example"
          > 
            <CustomTab label="Incidencias" value={0} />
            {CheckPermission("Nominas.PreNomina") && (
              <CustomTab label="Pre-Nómina" value={1} />
            )}
            {CheckPermission("Nominas.FiniquitoLiquidacion") && (
            <CustomTab label="Finiquito / Liquidación" value={2} /> )}
            {CheckPermission("Nominas.Eventuales") && (
            <CustomTab label="Eventuales" value={3} />)}
             {CheckPermission("Nominas.Historicas") && (
            <CustomTab label="Históricas" value={4} />)}
             {CheckPermission("Nominas.Calculadora") && (
            <CustomTab label="Calculadora" value={5} />)}
            {CheckPermission("Nominas.Reportes") && (
            <CustomTab label="Reportes" value={6} />)}
          </CustomTabs>
        </Grid>
      </Box>
      <div className={styles.pc_contenedorTitulo}>
      {getPayrollDataDispersar?.payroll_type === "Vales de Despensa" ? (
        <div className={styles.pc_contenedorProceso}>
          <div>
            <span className={styles.pc_tituloProceso}>Calcular</span>
            <span className={styles.pc_tituloProceso}>Timbrar</span>
            <span className={styles.pc_tituloProceso}>Terminar</span>
          </div>
          <div className={styles.pc_contenedorIconoSeguimiento}>
            <div className={styles.pc_circuloAmarillo}>
              <div className={styles.pd_iconoCompleto}></div>
            </div>
            <div className={styles.pc_lineaSeguimientoCompleto}></div>
            <div className={styles.pc_circuloAmarillo}>
              <div className={styles.pc_circuloBlanco}></div>    
            </div>
            <div className={styles.pc_lineaSeguimiento}></div>
            <div className={styles.pc_circuloGris}></div>
          </div>
        </div>
         ) :
         <div className={styles.pc_contenedorProceso}>
          <div>
            <span className={styles.pc_tituloProceso}>Calcular</span>
            <span className={styles.pc_tituloProceso}>Dispersar</span>
            <span className={styles.pc_tituloProceso}>Timbrar</span>
            <span className={styles.pc_tituloProceso}>Terminar</span>
          </div>
          <div className={styles.pc_contenedorIconoSeguimiento}>
            <div className={styles.pc_circuloAmarillo}>
              <div className={styles.pd_iconoCompleto}></div>
            </div>
            <div className={styles.pc_lineaSeguimientoCompleto}></div>
            <div className={styles.pc_circuloAmarillo}>
              <div className={styles.pd_iconoCompleto}></div>
            </div>
            <div className={styles.pc_lineaSeguimientoCompleto}></div>
            <div className={styles.pc_circuloAmarillo}>
              <div className={styles.pc_circuloBlanco}></div>    
            </div>
            <div className={styles.pc_lineaSeguimiento}></div>
            <div className={styles.pc_circuloGris}></div>
          </div>
        </div>
        }
        <div className={styles.pc_contenedorBotones}>
          {(CheckPermission("Nominas.Eventuales.Timbrar.Timbrar") && sistemaActivo) && (
              <div>
                {/* {
                  (payrollCancel?.length === 0 || payrollCancel === undefined)?
                    getPayrollDataDispersar?.dateFinish? null
                    :
                      (isCheck.length > 0 && timbrar)  ?
                        <button className={styles.pt_botonTimbrar}
                        onClick={() => timbrarNomina()}
                        >
                          <div className={styles.pd_iconoDerechaDos}></div>
                              Timbrar
                        </button>
                      :
                        <button className={styles.pt_botonTimbrarInActivo}>
                          <div className={styles.pd_iconoDerechaDos}></div>
                          Timbrar
                        </button>
                  :
                    (isCheck.length > 0) && timbrar ?
                      <button className={styles.pt_botonTimbrarCancelada}
                      onClick={() => timbrarNominaCancelada()}
                      >
                        <div className={styles.pd_iconoDerechaDos}></div>
                            Timbrar de nuevo
                      </button>
                    :
                      <button className={styles.pt_botonTimbrarCanceladaInActivo}>
                        <div className={styles.pd_iconoDerechaDos}></div>
                        Timbrar de nuevo
                      </button>
                } */}
                {
  activeReStamp ? (
    // Si activeReStamp es true → mostrar botón Timbrar de nuevo
    isCheck.length > 0 && timbrar ? (
      <button
        className={styles.pt_botonTimbrarCancelada}
        onClick={() => timbrarNominaCancelada()}
      >
        <div className={styles.pd_iconoDerechaDos}></div>
        Timbrar de nuevo
      </button>
    ) : (
      <button className={styles.pt_botonTimbrarCanceladaInActivo}>
        <div className={styles.pd_iconoDerechaDos}></div>
        Timbrar de nuevo
      </button>
    )
  ) : (
    // ---- LÓGICA ORIGINAL ----
    (payrollCancel?.length === 0 || payrollCancel === undefined) ?
      getPayrollDataDispersar?.dateFinish ? (
        null
      ) : (
        (isCheck.length > 0 && timbrar) ? (
          <button className={styles.pt_botonTimbrar}
            onClick={() => timbrarNomina()}
          >
            <div className={styles.pd_iconoDerechaDos}></div>
            Timbrar
          </button>
        ) : (
          <button className={styles.pt_botonTimbrarInActivo}>
            <div className={styles.pd_iconoDerechaDos}></div>
            Timbrar
          </button>
        )
      )
    :
      (isCheck.length > 0 && timbrar) ? (
        <button className={styles.pt_botonTimbrarCancelada}
          onClick={() => timbrarNominaCancelada()}
        >
          <div className={styles.pd_iconoDerechaDos}></div>
          Timbrar de nuevo
        </button>
      ) : (
        <button className={styles.pt_botonTimbrarCanceladaInActivo}>
          <div className={styles.pd_iconoDerechaDos}></div>
          Timbrar de nuevo
        </button>
      )
  )
}

              </div>           
          )}
             <div>
                       <>
                       <FormControlLabel
                       control={
                           <Checkbox
                             size="small"
                             style={{ color: "#FABB00" }}
                             checked={activeReStamp}
                             onChange={handleChangeActiveReStamp}
                            />
                       }
                       label="Habilitar re-timbrado"
                         />
                       </>
                     </div>
         {(getPayrollDataDispersar?.payroll_type === "PTU" || getPayrollDataDispersar?.payroll_type === "Aguinaldo") &&(
          <div>
           <button className={styles.pt_botonTimbrarCancelada}
                        onClick={() =>  openDataCancel(id, 'Eventual',getPayrollDataDispersar?.payroll_type)}
                        >
                          <div className={styles.pd_iconoDerechaDos}></div>
                              Cancelar  Timbrar
            </button>
          </div>
         )}
          {CheckPermission("Nominas.Eventuales.Timbrar.Terminar") && (
            bottonfinish()
          )}
        </div>
      </div>
      <div className={styles.pc_contenedorPrincipal}>

      {loading ? null :getPayrollDataDispersar?.payroll_type === "Vales de Despensa" ? (
                <div className={styles.pc_tituloContenedorPrincipal}>
                <div className={styles.pc_contenedorNombre}>
                  <div>
                    <span className={styles.pc_tituloPrincipal}>{tab}</span>
                    &nbsp;
                  <span className={styles.pc_tituloPrincipal}>
                    {getPayrollDataDispersar?.pantryVouchersMonth}
                  </span>
                &nbsp;
                  </div>
                </div>
              </div>
            ) :  <div className={styles.pc_tituloContenedorPrincipal}>
            <div className={styles.pc_contenedorNombre}>
              <div>
                <span className={styles.pc_tituloPrincipal}>{tab} </span>
              </div>
            </div>
          </div>
        }
        <div className={styles.pc_contenedorBuscadorDescargar}>
          <div className={styles.pc_contenedorBuscador}>
            <input 
              type="text" 
              placeholder="Buscar al colaborador por nombre"
              className={styles.pc_inputBuscador}
              onChange={(e) => datosFiltrados(e.target.value)}
              >
            </input>
            <div className={styles.pc_iconoBuscador}></div>
          </div>
        </div>
        <div className={styles.p_contenedorTablaDispersion}>
          <table className={styles.pd_tablaPrincipal}>
            <thead className={styles.pd_contenedorTitulos}>
              <td className={`${styles.pt_columna} ${styles.pt_primerColumna}`}>
                <div id="colaboladores" className={styles.checkboxitem}>
                  <input
                    id="check"
                    type="checkbox"
                    onChange={(e) => handleSelectAll(e)}
                  ></input>
                  <label htmlFor="check"> Colaboradores </label>
                </div>
              </td>
              <td className={`${styles.pt_columna} ${styles.pt_columnaTitulos}`}>RFC</td>
              <td className={`${styles.pt_columna} ${styles.pt_columnaTitulos}`}>Percepciones</td>
              <td className={`${styles.pt_columna} ${styles.pt_columnaTitulos}`}>Deducciones</td>
              <td className={`${styles.pt_columna} ${styles.pt_columnaTitulos}`}>Total</td>
              <td className={`${styles.pt_columna} ${styles.pt_columnaTitulos}`}></td>
            </thead>
            <tbody className={styles.pc_contenedorTitulos}>
              {
                filtrado?.map((payroll:any)=>(
                  <tr>
                    <td className={`${styles.pt_columnaDatos} ${styles.pt_primerColumna}`}>
                      <div id="colaboladores" className={styles.checkboxitem}>
                        <input
                          id={payroll.id}
                          key={payroll.id}
                          type="checkbox"
                          checked ={isCheck.includes(payroll.id)}
                          onChange={(e) => handleClick(e)}
                          value={payroll.id}
                          disabled={isValidPayroll(payroll)}
                        ></input>
                        <label htmlFor={payroll.id}>  {payroll.colaborator} </label>
                      </div>
                    </td>
                    <td className={styles.pt_columnaDatos}>{payroll.RFC}</td>
                    <td className={styles.pt_columnaDatos}>{formatter(payroll.perception)}</td>
                    <td className={styles.pt_columnaDatos}>{formatter(payroll.deduction)}</td>
                    <td className={styles.pt_columnaDatos}>{formatter(payroll.netIncomeTaxable)}</td>
                    <td className={`${styles.pt_columnaDatos}`}>
                      <div className={styles.divDoc}>
                        <div className={`${styles.divIconos}`}>
                          {
                            (!payroll.UUID || payroll.UUID === "") 
                            || 
                            ( (payroll.AcuseCancelacion && payroll.AcuseCancelacion !== "") && (payroll.UUID && payroll.UUID !== "") )?
                              <a
                                style={{ marginRight: "5px", marginLeft: "5px" }}
                                target="_blank"
               
                                onClick={() => {
                                  exportarPDF(payroll.id);
                                }}
                                rel="noreferrer"
                              >
                                <img
                                  src={prefactura}
                                  style={{ marginRight: "auto", marginLeft: "auto" }}
                                  className="cursor"
                                  alt="Descargar"
                                />
                              </a>
                            : ""
                          }
                          
                        </div>
                        <div>
                          {payroll.UUID && payroll.UUID !== ""?
                              <a
                                style={{ marginRight: "5px", marginLeft: "5px" }}
                                target="_blank"
                                href={payroll?.xml}
                                rel="noreferrer"
                              >
                                <img
                                  src={descargaXml}
                                  style={{ marginRight: "auto", marginLeft: "auto" }}
                                  className="cursor"
                                  alt="Descargar"
                                />
                              </a>
                          : "" }
                        </div>
                        <div>
                          {payroll.UUID && payroll.UUID !== ""?
                            <a
                              style={{ marginRight: "5px", marginLeft: "5px" }}
                              target="_blank"
                              href={payroll?.LinkPDF}
                              rel="noreferrer"
                            >
                              <img
                                src={iconoPDF}
                                style={{ marginRight: "auto", marginLeft: "auto" }}
                                className="cursor"
                                alt="Descargar"
                              />
                            </a>
                            : ""
                            }
                        </div>
                        <div>
                          {payroll.PDF_back && payroll.PDF_back !== ""?
                            <a
                              style={{ marginRight: "5px", marginLeft: "5px" }}
                              target="_blank"
                              href={payroll?.PDF_back}
                              title="CFDI cuenta con timbrado previos"
                              rel="noreferrer"
                            >
                              <img
                                src={iconoPDFAnterior}
                                style={{ marginRight: "auto", marginLeft: "auto", height: "25px" }}
                                className="cursor"
                                alt="DownloadFile"
                              />
                            </a>
                            : ""
                            }
                        </div>
                      </div>
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
        <div>
        {getPayrollDataDispersar?.payroll_type === "Vales de Despensa" ? (
          <div className={styles.pd_contenedorBarraEstado}>
          <div className={styles.pd_barraEstado} >
            <div className={styles.pd_contenedorRegreso}
              onClick={() =>history.push(`/InitEventualPayroll/${id}/${tab}`)}
            >
            <div className={styles.pd_botonRegreso}></div>
            <div>Regresar a "Calcular"</div>
            </div>
              <button className={styles.pd_botonSalir}
                onClick={() => history.push(`/payroll`)}
              >
                Salir
              </button>
          </div>
       </div>
          ) :
            <div className={styles.pd_contenedorBarraEstado}>
            <div className={styles.pd_barraEstado} >
              <div className={styles.pd_contenedorRegreso}
                onClick={() => history.push(`/EventualPayrollDispersar/${id}/${tab}`)}>
                <div className={styles.pd_botonRegreso}></div>
                <div>Regresar a "Dispersar"</div>
              </div>
              <button className={styles.pd_botonSalir}
                onClick={() => history.push(`/payroll`)}
              >
                Salir
              </button>
            </div>
          </div>
          }
        </div>
      </div>
      <ShowTerminar type="EVENTUAL" year={year} />
      {state.showDataCancelTimbre ? <DataCancelTimbre/>: null}
    </>
  );   
};

export default EventualPayrollTimbrar;
